import React from 'react';
import styles from '../Lead.module.css';

/* Pré-visualização do texto da minuta, na mesma marcação que o backend usa
   pro PDF/DOCX: "# título", "## cláusula", "- item", **negrito**, linha em
   branco separa parágrafo (quebra simples continua sendo quebra). [[campo]] = marcador sem dado (em vermelho) e
   {{campo}} = marcador ainda não preenchido (no editor de modelos). */
function trechos(texto, chave) {
  return String(texto).split(/(\*\*[^*]+\*\*|\[\[[a-z0-9_]+\]\]|\{\{\s*[a-z0-9_]+\s*\}\})/gi).filter(Boolean).map((t, i) => {
    const k = `${chave}-${i}`;
    if (t.startsWith('**') && t.endsWith('**')) return <strong key={k}>{t.slice(2, -2)}</strong>;
    if (t.startsWith('[[')) return <mark key={k} className={styles.marcadorVazio} title="Sem dado no lead">{t}</mark>;
    if (t.startsWith('{{')) return <mark key={k} className={styles.marcadorModelo}>{t}</mark>;
    return <React.Fragment key={k}>{t}</React.Fragment>;
  });
}

export function marcadoresVazios(texto) {
  return [...new Set((String(texto || '').match(/\[\[([a-z0-9_]+)\]\]/gi) || []).map(x => x.slice(2, -2)))];
}

function TextoMinuta({ texto }) {
  const saida = [];
  let paragrafo = [];
  const fechar = () => {
    if (paragrafo.length) {
      const k = saida.length;
      /* quebra de linha simples é mantida (bloco de assinatura etc.) */
      saida.push(<p key={`p${k}`}>{paragrafo.map((l, i) => <React.Fragment key={i}>{i > 0 && <br />}{trechos(l, `${k}-${i}`)}</React.Fragment>)}</p>);
      paragrafo = [];
    }
  };
  String(texto || '').replace(/\r/g, '').split('\n').forEach(linha => {
    const t = linha.trim();
    if (!t) { fechar(); return; }
    if (t.startsWith('## ')) { fechar(); saida.push(<h4 key={`h${saida.length}`}>{trechos(t.slice(3).replace(/\*\*/g, ''), saida.length)}</h4>); return; }
    if (t.startsWith('# ')) { fechar(); saida.push(<h3 key={`t${saida.length}`}>{trechos(t.slice(2).replace(/\*\*/g, ''), saida.length)}</h3>); return; }
    if (t.startsWith('- ')) { fechar(); saida.push(<p key={`l${saida.length}`} className={styles.minutaItem}>•&nbsp;&nbsp;{trechos(t.slice(2), saida.length)}</p>); return; }
    paragrafo.push(t);
  });
  fechar();
  return <div className={styles.minutaPreview}>{saida}</div>;
}

export default TextoMinuta;
